<template>
    <div v-if="simulation">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-lg-12">
                    <simulation
                        :registration="registration"
                        :simulation="simulation"
                        :competencies="competencies">
                    </simulation>

                    <tabs class="tabs"
                        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
                        tabContentClasses="card shadow"
                        v-if="registration.degree.simulation_role_2 && simulation.grid2"
                    >
                        <tab-pane id="grid1">
                            <span slot="title">
                                {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
                            </span>
                            <simulation-competencies
                                :registration="registration"
                                :simulation="simulation"
                                :learners="learners"
                                :competencies="competencies"
                                :rating-options="ratingOptions"
                                :num="1"
                            >
                            </simulation-competencies>
                        </tab-pane>

                        <tab-pane id="grid2">
                            <span slot="title">
                                {{ registration.degree.simulation_role_2_name[registration.degree.lang] }}
                            </span>
                            <simulation-competencies
                                :registration="registration"
                                :simulation="simulation"
                                :learners="learners"
                                :competencies="competencies"
                                :rating-options="ratingOptions"
                                :num="2"
                            >
                            </simulation-competencies>
                        </tab-pane>
                    </tabs>

                    <simulation-competencies
                        :registration="registration"
                        :simulation="simulation"
                        :learners="learners"
                        :competencies="competencies"
                        :rating-options="ratingOptions"
                        :num="1"
                        v-else
                    >
                    </simulation-competencies>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Simulation from './cohort/Simulation';
    import SimulationCompetencies from './cohort/SimulationCompetencies';

    export default {

        components: {
            Simulation, SimulationCompetencies,
        },

        data() {
            return {
                registration: null,
                simulation: null,
                learners: null,
                group: null,
                competencies: null,
                ratingOptions: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.$route.params.cohortId
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.simulation.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.$t('common.competencies'),
                    },
                ]
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/groups/'+to.params.groupId)
            .then(resp => {
                next(vm => {
                    vm.simulation = resp.data.data
                    vm.registration = resp.data.included.registration
                    vm.learners = resp.data.included.learners
                    vm.group = resp.data.included.group
                    vm.competencies = resp.data.included.competencies
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
